import { http } from '../../main'
import { store } from '../../store'

const state = {}

const getters = {}

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'api/role-permissions'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getPermissions ({commit, dispatch}, payload) {
    let url = 'api/permissions'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetPermissions', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({commit, dispatch}, payload) {
    let url = 'api/Roles'
    let params = {
      'name': payload.event.item.name,
      'guard_name': payload.event.item.guard_name
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  postPermission ({commit, dispatch}, payload) {
    let url = 'api/role-permissions'
    let params = {
      'role': payload.event.item.name,
      'permissions': {
        'permissions': payload.event.permission
      }
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('permissionPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({commit, dispatch}, payload) {
    let url = 'api/Roles/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name,
      'guard_name': 'api'
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  delete ({commit, dispatch}, payload) {
    let url = 'api/Roles/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  deletePermission ({commit, dispatch}, payload) {
    let url = 'api/role-permissions/' + payload.event.item.id + '/' + payload.event.permission
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDeletePermission', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let roles = payload.response.data.data
    payload.event.context.roles = roles
  },
  onGetPermissions (state, payload) {
    let permissions = payload.response.data.data
    payload.event.context.permissions = permissions
  },
  onPost (state, payload) {
    let rol = payload.response.data.data
    rol.name = rol.name
    rol.guard_name = 'api'
    rol.permissions = []
    let roles = payload.event.context.roles
    roles.push(rol)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  permissionPost (state, payload) {
    let rol = payload.response.data.data.role
    rol.name = rol.name
    rol.permissions = rol.permissions
    let roles = payload.event.context.roles
    roles.splice(payload.event.index, 1, rol)
    payload.event.context.roles = roles
    payload.event.context.permissionsItem = rol
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closePermission()
  },
  onPut (state, payload) {
    let rol = payload.response.data.data
    rol.name = rol.name
    rol.id = rol.id
    let roles = payload.event.context.roles
    let putRol = roles.find(item => item.id === rol.id)
    putRol.name = rol.name
    roles.splice(payload.event.index, 1, putRol)
    payload.event.context.roles = roles
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onDelete (state, payload) {
    let roles = payload.event.context.roles
    roles.splice(payload.event.index, 1)
    payload.event.context.roles = roles
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.removeDialog = false
    payload.event.context.loading = false
  },
  onDeletePermission (state, payload) {
    let roles = payload.event.context.roles
    let rol = roles[payload.event.index]
    let permission = payload.response.data.data.role.permissions[0]
    let id = rol.permissions.findIndex(item => item.id === permission.id)
    rol.permissions.splice(id, 1)
    roles.splice(payload.event.index, 1, rol)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closePermission()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js